<template>
  <div class="sort-gift">
    <headerNotice routerName="礼品分类管理"></headerNotice>
    <!-- 头部操作栏 -->
    <div class="handleBar">
      <el-row :gutter="20">
        <el-col :span="2" :offset="2">
          <el-button type="primary" @click="openDialog">
            <i class="el-icon-plus"></i> 新增
          </el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 排序列表 -->
    <div class="sortBox" v-loading="loading">
      <el-tree
        :data="itemsData"
        :draggable="true"
        :expand-on-click-node="false"
        highlight-current
        :props="{
                    children:'cates'
                }"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ data.cateName }}</span>
          <span>
            <!-- <el-button type="text" v-if="node.level==1" size="mini" @click="append(node,data)">新增</el-button> -->
            <el-button type="text" size="mini" @click="remove(node, data)">删除</el-button>
          </span>
        </span>
      </el-tree>
    </div>

    <!-- dialog弹框 -->
    <el-dialog class="dialogBox" title="新增礼品分类" :visible.sync="showDialog" width="30%">
      <!-- <el-form label-width="120px" v-if="formData.parentID">
        <el-form-item label="上级分类">
          <el-input readonly v-model="parentCateName"></el-input>
        </el-form-item>
      </el-form> -->
      <el-form label-width="120px">
        <el-form-item label="分类名称" :rules="[{'required':true}]">
          <el-input type='textarea' resize="none" :maxlength="25" placeholder="请输入名分类名称，≤25个字" v-model="formData.cateName"></el-input>
        </el-form-item>
      </el-form>
      <!-- <el-form label-width="120px">
        <el-form-item label="搜索关键字">
          <el-input type="textarea" placeholder="多个关键词用英文逗号'，'隔开。" v-model="formData.words"></el-input>
        </el-form-item>
      </el-form> -->
      <div class="confirmBtn">
        <el-button type="primary" class="confirmBtn" @click="confirmData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerNotice from "../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: true,
      totalCount: 0, //总数据条数
      maxResultCount: 100, //默认一页显示的个数,
      showDialog: false,
      itemsData: [],
      parentCateName: "",
      formData: {
        // parentID: 0,
        cateName: "",
        // words: ""
      }
    };
  },
  components: {
    headerNotice
  },
  created() {
    this.getDatas();
  },
  methods: {
     // 获取分类
    getIntegralItemCate(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetIntegralItemCate",
        params: params,
        success(res) {
          // console.log(res);
          // self.loading = false
          self.typeOption = self.dealTypeOption(res)
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    //获取列表数据
    getDatas() {
      let self = this;
      $http.GET({
        url: this.$store.state.apiUrl + "/api/services/app/AdminIntegralExchange/GetIntegralItemCate",
        success(res) {
          self.itemsData = res;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //新增分类 打开弹框
    openDialog() {
      this.formData = {
        // parentID: 0,
        cateName: "",
        // words: ""
      };
      this.showDialog = true;
    },
    //确认添加按钮
    confirmData() {
      let self = this;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/CreateIntegralCate",
        data: this.formData,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.getDatas();
          self.showDialog = false;
        },
        fail(res) {}
      });
    },
    //增加分类
    append(node, data) {
      this.parentCateName = data.cateName;
      this.formData = {
        // parentID: data.cateID,
        cateName: "",
        // words: ""
      };
      this.showDialog = true;
    },
    //移除分类
    remove(node, data) {
      let self = this;
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          $http.DELETE({
            url:
              this.$store.state.apiUrl +
              "/api/services/app/AdminIntegralExchange/DeleteCate",
            params: {
              cateID: data.cateID
            },
            success(res) {
              self.$message({
                message: "删除成功",
                type: "success"
              });
              self.getDatas();
            },
            fail(res) {}
          });
        }).catch(() => {});
    }
  }
};
</script>

<style lang='scss' scoped>
.handleBar {
  margin-top: 20px;
}
.confirmBtn {
  text-align: center;
}
</style>
<style lang="scss">
.sort-gift {
  .sortBox {
    margin: 20px 100px;
    background: #f9f9f9;
    border: 1px solid #c5c5c5;
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .el-tree-node {
    }
    .el-tree-node__content {
      height: 50px;
    }
  }
}
</style>